export default "__VITE_ASSET__6353623e__"